import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venue-accomodation25',
  templateUrl: './venue-accomodation25.component.html',
  styleUrls: ['./venue-accomodation25.component.css']
})
export class VenueAccomodationComponent25 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
